import { forwardRef } from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeStyles = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-4',
};

export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
  ({ size = 'md', className = '' }, ref) => {
    return (
      <div
        ref={ref}
        className={`
          inline-block rounded-full
          border-primary-600 border-t-transparent
          animate-spin
          ${sizeStyles[size]}
          ${className}
        `}
      />
    );
  }
);

Spinner.displayName = 'Spinner';

interface LoadingOverlayProps {
  message?: string;
}

export function LoadingOverlay({ message = 'Memuat...' }: LoadingOverlayProps) {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Spinner size="lg" className="mx-auto mb-4" />
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
}
